import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'numberTranslate',
  pure: false,
})
export class NumberTranslatePipe implements PipeTransform {
  private arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

  transform(value: number | string | undefined | null): string {
    if (value === null || value === undefined) return '';

    // If language is English, return the original value without translation
    if (window.LANG === 'en') {
      return value.toString();
    }

    const strValue = value.toString();
    if (!/^-?\d*\.?\d*$/.test(strValue)) return strValue;

    // Replace each digit with its Arabic equivalent
    let result = '';

    for (const char of strValue) {
      if (char >= '0' && char <= '9') {
        result += this.arabicNumbers[parseInt(char, 10)];
      } else {
        result += char;
      }
    }
    return result;
  }

  /**
   * Replace ASCII digits inside any string with Arabic-Indic digits when current language is Arabic.
   */
  translateDigitsInString(value: string): string {
    if (value === null || value === undefined) return '';
    if (window.LANG === 'en') return value.toString();

    const input = value.toString();
    let output = '';
    for (const char of input) {
      if (char >= '0' && char <= '9') {
        output += this.arabicNumbers[parseInt(char, 10)];
      } else {
        output += char;
      }
    }
    return output;
  }
}
